// extracted by mini-css-extract-plugin
export const insightButton = "InsightButton__insightButton__HglxZ";
export const fullWidth = "InsightButton__fullWidth__K0rIR";